import { render, staticRenderFns } from "./big.vue?vue&type=template&id=38f7d257&scoped=true&"
import script from "./big.vue?vue&type=script&lang=js&"
export * from "./big.vue?vue&type=script&lang=js&"
import style0 from "./big.vue?vue&type=style&index=0&id=38f7d257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7d257",
  null
  
)

export default component.exports